<template>
	<a class="cursor-pointer d-flex align-center">
		<img :src="logoSrc" alt="Passporter" :style="{ height: isXS ? '23px' : '24px' }" />
	</a>
</template>
<script setup lang="ts">
	import whitePassporterlogo from '~/assets/logo.svg'
	import geenPassporterLogo from '~/assets/logoNegative.svg'
	import { computed } from 'vue'

	interface Props {
		isXS?: boolean
		useGreenLogo?: boolean
	}
	const props = defineProps<Props>()
	const logoSrc = computed(() => (props.useGreenLogo ? geenPassporterLogo : whitePassporterlogo))
</script>
